import ProductVariantGroupsConnector from './product-variant-groups-connector'
import ProductVariantsConnector from './product-variants-connector'

class MiddlewareConnector {
    /** @type{string} */
    _middlewareUrl
    /** @type{ProductVariantGroupsConnector} */
    productVariantGroups
    /** @type{ProductVariantsConnector} */
    productVariants



    /**
     * @param {string} middlewareUrl The url to the middleware used as base url for the endpoints.
     */
    constructor(middlewareUrl) {
        this._middlewareUrl = middlewareUrl
        this.productVariantGroups = new ProductVariantGroupsConnector(middlewareUrl)
        this.productVariants = new ProductVariantsConnector(middlewareUrl)
    }
}

export default MiddlewareConnector